import { Component, OnInit, Input } from '@angular/core';
import { SellerModel } from '../seller-main/seller-main.component';




@Component({
  selector: 'app-seller',
  templateUrl: './seller.component.html',
  styleUrls: ['./seller.component.scss']
})
export class SellerComponent implements OnInit {

  @Input() seller: SellerModel;
  
  constructor() { }

  ngOnInit() {
  }


}
